import axios, { InternalAxiosRequestConfig } from 'axios';
interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  useTokens?: boolean;
}

const uuid = require('uuid/v4');
import AuthForgeRock from './actions/auth/auth';
const auth = new AuthForgeRock();

export const requireTokens = () => {
  axios.interceptors.request.use((config:CustomAxiosRequestConfig) => {
    if(!('useTokens' in config) && config.headers){
      config.headers.set("Authorization", `Bearer ${auth.getAccessToken()}`);
      config.headers.set("x-id-token", `${auth.getIdToken()}`);
    }
    return config;
  });
}

export const requireCorrelationId = () => {
    axios.interceptors.request.use((config:InternalAxiosRequestConfig) => {                
        if (config.headers) {
          config.headers.set("x-correlation-id", uuid());
        };        
        return config;
    });
}

export const requireSessionId = () => {
    axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      if(localStorage.getItem("x-session-id") === null) {
        localStorage.setItem("x-session-id", uuid())
      }
      if (config.headers) {
        config.headers.set("x-session-id", localStorage.getItem("x-session-id") || "");
      }
      return config;
    });
  };